import { render, staticRenderFns } from "./ContainerPedidos.vue?vue&type=template&id=e8d5a37a&scoped=true"
import script from "./ContainerPedidos.vue?vue&type=script&lang=js"
export * from "./ContainerPedidos.vue?vue&type=script&lang=js"
import style0 from "./ContainerPedidos.vue?vue&type=style&index=0&id=e8d5a37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d5a37a",
  null
  
)

export default component.exports